import React, {
  ChangeEventHandler,
  FocusEventHandler,
  HTMLInputTypeAttribute,
  KeyboardEventHandler,
} from "react"
import { cn } from "@malond/ui/utils"

type Props = {
  id?: string
  type?: HTMLInputTypeAttribute
  name: string
  value?: string | number | undefined
  defaultValue?: string | number | undefined
  onChange?: ChangeEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
  withLabel?: boolean
  isError?: boolean
  isDisabled?: boolean
  className?: any
  placeholder?: string
  autoFocus?: boolean
}

export default function Input({
  id,
  type = "text",
  name,
  value,
  defaultValue,
  onChange,
  onBlur,
  onKeyDown,
  withLabel = false,
  isError = false,
  isDisabled = false,
  className = "",
  placeholder,
  autoFocus,
}: Props) {
  return (
    <input
      type={type}
      name={name}
      id={id || name}

      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      autoComplete={name}
      placeholder={placeholder}
      autoFocus={autoFocus}
      disabled={isDisabled}
      className={cn(
        "flex h-10 w-full rounded-md border px-3 py-2 text-sm shadow-xs transition-colors",
        "bg-background text-foreground placeholder:text-muted-foreground",
        "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none",
        "disabled:cursor-not-allowed disabled:opacity-50",
        isError
          ? "border-destructive focus-visible:ring-destructive"
          : "border-input",
        withLabel && "mt-1",
        className
      )}
    />
  )
}
